import React, { useEffect } from 'react';
import './styles.css';
import { useLocation } from 'react-router';

import { IdentityGender } from '../../../helpers/constants';
import ContractsService from '../../../services/constracts.service';
import './Contracts.scss';

const ContractDebit = props => {
  const location = useLocation();
  const { application } = location.state;

  const expirationDate = application.expirationDate
    ? new Date(application.expirationDate)
    : null;
  const birthdate = application.birthdate
    ? new Date(application.birthdate)
    : null;

  useEffect(function () {
    ContractsService.auditDebitContract(application.userId);
    window.print();
  });

  return (
    <>
      <div className="contract-body body" dir="rtl">
        {/* الصفحة الأولى */}
        <div
          style={{
            textAlign: 'left',
            marginTop: '4px',
            marginBottom: '4px',
            marginLeft: '15px',
          }}
        >
          <img
            src="https://cx-admin.thelucky.io/img/Lucky-logo-full.39484ca1.svg"
            alt="Lucky One"
            style={{
              width: '60px',
              height: 'auto',
              display: 'inline-block',
            }}
          />
        </div>
        {/* HEADER */}
        <div className="text-center">
          {/* <img src="/luckyone-logo.png" style={{ height: '40px' }} /> */}
          <h5>طلب إصدار بطاقة دفع مطبوعة للعملاء</h5>
        </div>
        {/* MAIN FORM */}
        <h5>البيانات الشخصية</h5>
        <div className="contract-border compact-border">
          {/* FULL NAME */}
          <p>
            <span className="ml-3" style={{ minWidth: '150px' }}>
              الاسم بالكامل ( كما في بطاقة الرقم القومي)
            </span>
            <span className="underlineDotted " style={{ minWidth: '200px' }}>
              {application.firstName} {application.secondName}{' '}
              {application.thirdName} {application.familyName}
            </span>
          </p>

          {/* NATIONAL ID */}
          <p>
            <span className="ml-2">الرقم القومي:</span>
            <span dir="ltr">
              {application.documentNumber?.split('').map((n, i) => (
                <span key={i} className="idBox">
                  {n}
                </span>
              ))}
            </span>
          </p>
          <p className="flex items-center gap-10">
            {/* EXPIRY */}
            <span className="flex items-center gap-2">
              <span>تاريخ انتهاء صلاحية البطاقة:</span>
              <span dir="ltr" className="flex">
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {expirationDate?.getUTCDate()}
                </span>
                /
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {expirationDate ? expirationDate.getUTCMonth() + 1 : null}
                </span>
                /
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {expirationDate?.getUTCFullYear()}
                </span>
              </span>
            </span>

            <span className="flex items-center gap-2">
              <span> تاريخ الميلاد:</span>
              <span dir="ltr" className="flex">
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {birthdate?.getUTCDate()}
                </span>
                /
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {birthdate ? birthdate.getUTCMonth() + 1 : null}
                </span>
                /
                <span className="underlineDotted" style={{ minWidth: '30px' }}>
                  {birthdate?.getUTCFullYear()}
                </span>
              </span>
            </span>
          </p>

          {/* BIRTH  PLACE */}
          <p>
            <span className="ml-5">محل الميلاد:</span>
            <span className="underlineDotted" style={{ minWidth: '200px' }}>
              {application.placeOfBirth}
            </span>

            <span className="ml-3">النوع:</span>

            <span className="mr-2">ذكر</span>
            <span
              className={`square-kyc ${
                application.gender === IdentityGender.MALE ? 'cross' : ''
              }`}
            ></span>

            <span className="mr-3">أنثى</span>
            <span
              className={`square-kyc ${
                application.gender === IdentityGender.FEMALE ? 'cross' : ''
              }`}
            ></span>
          </p>

          {/* PHONE + EMAIL*/}
          <p>
            <span className="ml-3">رقم الهاتف المحمول:</span>

            <span className="underlineDotted" style={{ minWidth: '150px' }}>
              {application.phone}
            </span>

            <span className="ml-3">البريد الالكتروني:</span>

            <span
              className="underlineDotted"
              style={{ minWidth: '150px' }}
            ></span>
          </p>

          {/* ADDRESS */}
          <p>
            <span className="ml-3">عنوان محل الاقامة:</span>

            <span className="underlineDotted" style={{ minWidth: '350px' }}>
              {application.address}
            </span>
          </p>
        </div>
        <h4>بيانات العمل</h4>
        <div className="contract-border">
          {/* JOB */}
          <p>
            <span className="ml-3">المهنة و جهة العمل:</span>

            <span className="underlineDotted" style={{ minWidth: '250px' }}>
              {application.profession}
            </span>

            <span className="ml-3">عنوان العمل:</span>

            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>
          </p>

          <p>
            <span className="ml-3">نوع النشاط في حالة العميل صاحب عمل:</span>

            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>

            <span className="ml-3">اجمالى الدخل الشهرى:</span>

            <span
              className="underlineDotted"
              style={{ minWidth: '100px' }}
            ></span>
          </p>
        </div>
        {/* COMPLIANCE QUESTIONS */}
        <div className="contract-border p-3 mt-3 compliance-questions-compact">
          <p>
            هل أنت مواطن أمريكي أو مقيم في الولايات المتحدة الأمريكية أو حامل
            البطاقة الخضراء أو ولدت في الولايات المتحدة؟
            <span className="checkbox-label">نعم</span>
            <span className="square-kyc"></span>
            <span className="checkbox-label">لا</span>
            <span className="square-kyc"></span>
          </p>

          <p>
            أنا أعتبر حالياً أو سابقاً ( من ذوي المناصب العامة العليا )؟
            <span className="checkbox-label">نعم</span>
            <span className="square-kyc"></span>
            <span className="checkbox-label">لا</span>
            <span className="square-kyc"></span>
          </p>

          <p>
            لی ارتباط مباشر بمن يشغل حاليا أو سابقا أحد المناصب العامة العليا{' '}
            <span className="checkbox-label">نعم</span>
            <span className="square-kyc"></span>
            <span className="checkbox-label">لا</span>
            <span className="square-kyc"></span>
          </p>

          <p>
            (انظر البند الأخير في الشروط والأحكام للاطلاع على تعريف تولى المناصب
            العامة العليا أو الارتباط بمن يتولاها حتى الدرجة الثانية)
          </p>
        </div>
        <h4>بموجب هذا الطلب يتعهد المستخدم ويقر بما يلى:</h4>
        {/* TERMS */}
        <div className="contract-border p-3 mt-3">
          <ol className="dots terms-list-compact">
            <li>
              اقر أن كافة البيانات الواردة بهذا الطلب حقيقية وصحيحة وأتعهد
              بتحديث بياناتي فور حدوث تغييرات بشأنها أو عند الطلب أو عندما يطلب
              البنك ذلك في موعد اقصاء ( 30 ) يوم اً من تاريخ حدوث هذا التغيير ،
              كما أقبل أن يحتفظ البنك بهذا الطلب والمستندات المرفقة في حالة
              الغاء الخدمة
            </li>
            <li>
              اقر أني المستفيد الحقيقي والحائز الوحيد لبطاقة الدفع المربوطة
              بالخدمة والمسجل رقمها بهذا الطلب
            </li>
            <li>
              اقر ان جميع المعاملات التي تتم من خلال الخدمة المذكورة هي معاملات
              مشروعة وتستخدم في أغراض مشروعة ولأشخاص غير محظور التعامل معهم وأن
              جميع المعاملات تتم تحت مسئوليتي الشخصية
            </li>
            <li>
              اقر أنى قد اطلعت على كافة الشروط وأحكام خدمة الدفع عن طريق
              البطاقات المدفوعة مقدماً ، وأوافق على شروط وأحكام هذا الطلب ، كما
              اقر وأتعهد بتقديم المعلومات والمستندات اللازمة عند الطلب وحال
              الاقتضاء
            </li>
            <li>
              أقر أنى قد اطلعت على كافة شروط وأحكام الخدمة الموجودة على تطبيق
              الهاتف المحمول لاكي ، وأوافق على شروط وأحكام هذا الطلب
            </li>
            <li>
              أقر ان موظف المبيعات قام بعرض كافة التفاصيل المتعلقة بالشروط
              والاحكام وأسعار الخدمات واطلعت عليها عبر الموقع الالكتروني الخاص
              بالشركة ، وأنى على علم بكافة التفاصيل .
            </li>
            <li>
              اقر أنى قد اطلعت على تعريف تولى المناصب العامة / السياسية العليا
              أو الارتباط بمن يتولاها
            </li>
            <li>
              اقر أنى يعتبر توقيعي على هذا النموذج بمثابة موافقه على الالتزام
              بكافة الشروط والأحكام الواردة بهذا الطلب وأي تعديلات أو إضافات
              يقوم البنك بإدخالها عليه تماشيا مع ما يصدر من قوانين أو لوائح أو
              إجراءات البنك الداخلية في هذا الشأن مع التزام البنك بموافاة
              العميلبها دوري اً على النحو المبين من هذا الطلب
            </li>
            <li>
              أقر انني على دراية بالمدة اللازمة لتنفيذ أي من الطلبات المتعلقة
              بإصدار البطاقة، والتي تم توضيحها من موظف المبيعات بالشركة ، على ان
              يتم التنفيذ خلال 2 يوم عمل ، وفى حالة تأخر تلك المدة يتم الاتصال
              بأرقام خدمة العملاء الخاصة بالشركة أو الخط الساخن ( 16629 ) او من
              خلال فروع الشركة .
            </li>
            <li>
              يحق للعميل استلام نسخة من النماذج والعقود الموقع عليها حال طلبه
              لذلك
            </li>
            <li>
              لن يتم فرض رسوم إضافية عن رسوم اصدار البطاقة المعتمدة والمعلنة من
              شركة لاكي على العملاء عند استخدام الخدمات المصرفية المتعاقد عليها
              مع البنك ، وفي حال حدوث ذلك يمكن للعميل التقدم بشكوى للشركة عن
              طريق القنوات المتاحة المذكورة بهذا الطلب
            </li>
          </ol>
        </div>
        <h3>
          بموجب هذا الطلب يتعهد موظف مبيعات مقدم الخدمة ويقر بما يلي : اقراني قد
          اطلعت على اصل البطاقة الشخصية للعميل
        </h3>
        {/* SIGNATURE */}
        <div className="contract-border p-3 mt-3">
          <p>
            <span>توقيع مستخدم الخدمة:</span>
            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>

            <span className="mr-5">توقيع موظف المبيعات:</span>
            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>
          </p>

          <p>
            <span>التاريخ:</span>
            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>

            <span className="mr-10">التاريخ:</span>
            <span
              className="underlineDotted"
              style={{ minWidth: '200px' }}
            ></span>
          </p>
          <p>
            تم مراجعة الطلب بمعرفتي وتم التأكد من كافة البيانات المسجلة بالطلب
            ومطابقتها بالبيانات التي تم تسجيلها على النظام:
          </p>
          <p>
            <span className="mr-13">توقيع موظف المراجع</span>
            <span
              className="underlineDotted"
              style={{ minWidth: '150px' }}
            ></span>
          </p>
        </div>
        {/* BANK SECTION */}
        <div className="contract-border p-3 mt-3" style={{ direction: 'rtl' }}>
          <h3 className="text-center mb-4" style={{ fontWeight: 'bold' }}>
            البيانات الخاصة بمراجعة الطلب من جانب البنك ( تملي بواسطة البنك )
          </h3>

          <div dir="ltr" style={{ direction: 'ltr', textAlign: 'left' }}>
            {/* Row 1: Risk Level and Risk Matrix */}
            <div className="d-flex justify-content-between   mb-3">
              <div
                style={{ flex: '0 0 50%' }}
                className="d-flex align-items-center"
              >
                <span className="me-2">Risk level:</span>
                <span className="me-1">L1</span>{' '}
                <span className="square-kyc me-3"></span>
                <span className="me-1">L2</span>{' '}
                <span className="square-kyc me-3"></span>
                <span className="me-1">L3</span>{' '}
                <span className="square-kyc"></span>
              </div>
              <div style={{ flex: '0 0 50%' }}>
                Risk Matrix: <span className="underlineDotted w-100"></span>
              </div>
            </div>

            {/* Row 2: Purpose and KYC Amount */}
            <div className="d-flex justify-content-between mb-3">
              <div style={{ flex: '0 0 50%' }}>
                Purpose of account opening: prepaid card-lucky
              </div>
              <div style={{ flex: '0 0 45%' }}>KYC Currency Amount: EGP</div>
            </div>

            {/* Row 3: Signatures */}
            <div className="contract-border signature-block">
              <div style={{ flex: '0 0 45%' }}>
                Bank maker signature:{' '}
                <span className="underlineDotted w-100"></span>
              </div>
              <div style={{ flex: '0 0 45%' }}>
                Bank checker signature:{' '}
                <span className="underlineDotted w-100"></span>
              </div>
            </div>
          </div>
        </div>
        <div className="page-break"></div>
        <div>
          <div
            style={{
              textAlign: 'left',
              marginTop: '4px',
              marginBottom: '4px',
              marginLeft: '15px',
            }}
          >
            <img
              src="https://cx-admin.thelucky.io/img/Lucky-logo-full.39484ca1.svg"
              alt="Lucky One"
              style={{
                width: '60px',
                height: 'auto',
                display: 'inline-block',
              }}
            />
          </div>

          <h2 className="text-center">شروط واحكام عامة</h2>
          <ol dir="rtl" class="dots terms-list-compact-second-page">
            <li>
              <span>تمهيد:</span>
              يتضمن هذا الطلب شروط وأحكام استخدام خدمة الدفع عن البطاقات
              المدفوعة مقدماً، وهي بطاقات الدفع الإلكترونية التي يتم تغذيتها
              مقدماً من قبل العميل، بحيث يستطيع المستخدم فتح حساب بطاقة مدفوعة
              مقدماً لدى بنك قناة السويس ("البنك") للتعامل عليها سواء بالإيداع،
              السحب، أو التحويل الإلكتروني للأموال. ويُودع بالحساب رصيد الكتروني
              (وحدات النقود الإلكترونية) بمقدار ما أودعه المستخدم في حساب
              البطاقة لدى البنك، ويجوز له استخدام البطاقة في عمليات الشراء،
              والتحويلات، والسحب النقدي في حدود القيمة المتاحة فيها. ويتعين على
              المستخدم قراءة كافة شروط وأحكام استخدام الخدمة بدقة وعناية قبل
              التوقيع.
            </li>

            <li>
              فور توقيع المستخدم على هذا طلب، وشريطة استيفائه باقي الشروط الأخرى
              واستكمال إجارءات فتح البطاقة المدفوعة مقدما، وبعد التحقق من هويته
              من قبل الشركة، سيتم تفعيل خدمة الدفع عن طريق البطاقة المدفوعة
              مقدما من خلال منح المستخدم البطاقة الخاصة به الصادرة من شركة ميزه
              / فيزا ويتم تسليم المستخد م ال PIN MAILER الخاص به او رابط تحميل
              التطبيق علي متجر التطبيقات مع اجراءات التسجيل المطلوب القيام بها
              من قبل المستخدم عند التسجيل بالخدمة، وعلى المستخدم القيام بعملية
              التسجيل مرة أخرى من خلال التطبيق في حالة تغيير المستخدم لهاتفه.
            </li>
            <li>
              يحق للعميل أن يتعامل على رصيده الإلكتروني عن طريق الإيداع من خلال
              كافة ماكينات الصراف الألى الخاصة بمصرفنا أو سحب مبالغ من ك افة
              ماكينات الصراف الآلي الخاصة بالبنك، وأيضا الشراء من خلال نقاط
              البيع الالكترونية والشراء عبر الإنترنت، وذلك في ضوء المحددات
              الموضوعة من قبل البنك والبنك المركزي في هذا الشأن.
            </li>

            <li>
              وحال وجود أي منازعات تتعلق بالمعاملات المالية أو تقديم شكاوى من
              قِبل مستخدمي النظام، فإن عمليات تسوية المنازعات تخضع للقواعد والإ
              جراءات الثابتة والمعلنة من قبل البنك والشركة لمستخدمي النظام.
            </li>
            <li>
              ويوافق مستخدم النظام على أن تكون هذه القواعد جزءاً من الاتفاق
              المبرم بينه وبين البنك/الشركة، وأن تُعتبر سجلات النظام دليلاً
              قاطعاً على جميع المعاملات المنفذة، وذلك بشرط عدم وجود خلل فني في
              النظام، وتوفر سجلات كاملة وواضحة للمعاملات محل المنازعة
            </li>
            <li>
              يحق لمستخدم الخدمة في أي وقت إغلاق حساب البطاقة المدفوعة مقدماً
              واسترداد الرصيد النقدي المتبقي، وذلك بالتوجه إلى أحد فروع الشركة
              وتقديم طلب إغلاق الحساب. وتتم عملية الإغلاق ووقف الخدمة خلال خمسة
              عشر (15) يوم عمل من تاريخ استلام طلب الأغلاق، مع مسح كافة بيانات
              المستخدم ما لم يطلب المستخدم الاحتفاظ بها. وفي جميع الأحوال، لا
              يحق لمستخدم الخدمة مطالبة البنك أو الشركة أو الرجوع عليهما بوجود
              أي رصيد متبق بعد انقضاء المدة المشار إليها، وذلك دون أدنى مسئولية
              على البنك أو الشركة .
            </li>

            <li>
              يقتصر الحق في استخدام الخدمة أو الانتفاع بها على المستخدم وحده دون
              غيره، ويلتزم المستخدم في جميع الأوقات بعدم السماح أو تمكين أي شخص
              آخر من استخدامها أو الانتفاع بها، ويحق للبنك و/أو للشركة وفقاً
              لمطلق تقديرهما، إيقاف الخدمة عن المستخدم أو إلغاؤها في حال
              استخدامه لها بالمخالفة لأي من شروط وأحكام خدمه الدفع عبر البطاقات
              المدفوعة مقدما أو بالمخالفة لأي من القوانين واللوائح واجبة
              التطبيق.
            </li>
            <li>
              يحق للبنك، ودون الحاجة إلى الرجوع إلى المستخدم، تقييد أو إغلاق
              حساب المستخدم في أي وقت حسب الاقتضاء إذا كان ذلك مطلوباً بموجب
              القانون أو الاتفاقيات الدولية، أو إذا كان لدى البنك أسباب معقولة
              أو مؤيدة لاحتيال المستخدم أو لاستخدام الحساب في أغراض غير مشروعة
              أو غير لائقة، أو بما يخالف القوانين السارية أو شروط وأحكام
              الحسابات المصرفية المعمول بها لدى بالبنك. كما يجوز للبنك تجميد أو
              إغلاق الحساب إذا كان المستخدم ضحية للاحتيال أو سرقة الهوية، وذلك
              لتفادي الخسائر المحتملة.
            </li>
            <li>
              ويحق للبنك رفض تنفيذ أي معاملة مصرفية في حال إخلال المستخدم بأي من
              شروط وأحكام هذا الطلب، أو إذا قَدَّم تعليمات غامضة أو متن اقضة أو
              غير مقبولة لدى البنك أو إذا شك البنك في وجود حالات غش أو معاملات
              غير قانونيه أو غير مشروعة. كما يجوز للبنك أن يبلغ عن أي عمليات غسل
              أموال أو معاملات مشكوك فيها أو غير قانونية إلى السلطات الرقابية
              المختصة داخل جمهورية مصر العربية أو خارجها، التزاماً منه بجميع
              قوانين مكافحة غسل الأموال. ويجوز للبنك، وفقاً لتقديره المطلق، طلب
              أي تفاصيل أو معلومات اضافيه من المستخدم وتقديمها إلى السلطات
              المعنية. وفي تلك الحالات، لا يتحمل البنك و/أو الشركة أي مسؤولية أو
              التزام عن تأخير أو عدم تنفيذ المعاملات إذا لم يقدم المستخدم
              المعلومات المطلوبة في الوقت المحدد.
            </li>
            <li>
              يلتزم المستخدم بالمحافظة على الرقم السري الخاص به وابقائه في جميع
              الأوقات تحت مسئوليته الشخصية، ويكون المستخدم وحده مسؤولاً عن أي
              افشاء للبيانات أو المعلومات المتعلقة به أو بأي من حساباته إذا كان
              هذا الإفشاء ناشئاً عن خطأ أو تقصير أو إهمال في المحافظة على رقمه
              السري الخاص به، وذلك دون أدنى مسئولية على البنك و/أو الشركة.
            </li>
            <li>
              ويتحمل المستخدم كامل المسؤولية عن جميع المعاملات وكافة العمليات
              التي تتم على حساب البطاقة المرتبطة بالخدمة وباستخدام الرقم السري
              الخاص به، وتُعد دفاتر البنك وسجلاته حجة قاطعة على المستخدم والغير
              في هذا الخصوص. ولا يتحمل البنك و/أو الشركة أي مسؤولية عن أية خسائر
              أو أضرار قد تحدث للمستخدم بسبب سوء أو إساءة استخدامه للخدمة أو
              نتيجة أي خطا تقصير منه أو لعدم كفاية الرصيد في حساب البطاقة أو لأي
              سبب آخر قد يكون للمستخدم دخل فيه، كما لا يكون البنك و/أو الشركة
              مسؤولاً عن أي خلل في شبكات الاتصالات أو تحمله أية تكاليف أو اعباء
              قد تحدث نتيجة لقطاع الخدمة بشبكة الانترنت أو من جراء اية مشاكل او
              اعطال قد تطرأ على الشركة.
            </li>

            <li>
              ولا يكون البنك و/أو الشركة مسؤولاً عن رفض أي مؤسسة قبول الرصيد
              الإلكتروني كوسيلة سداد، كما أنه لا يتحملان أي مسؤولية عن جودة أو
              طبيعة البضائع أو الخدمات التي سوف يحصل عليها المستخدم مقابل ذلك
              الرصيد، وعلى المستخدم توجيه أي شكوى في هذا الصدد مباشرة إلى الجهة
              أو المؤسسة المعنية، ويقتصر دور البنك و/أو الشركة في هذا الخصوص على
              إضافة أي مبالغ يسترده المستخدم إلى حساب البطاقة وذلك بعد حصول
              البنك على مستند إضافة صادر بشكل صحيح من تلك المؤسسة.
            </li>
            <li>
              يتعين على المستخدم ابلاغ الشركة فوا رً في حالة سرقة البطاقة أو
              الهاتف المحمول أو فقد أي منهما، أو في حال قيام شخص آخر بإجراء أ ي
              تعاملات على حسابات المستخدم. ويُعتبر المستخدم مسؤولا مسؤولية كاملة
              تجاه البنك و/أو الشركة عن كافة النتائج المترتبة على تلك المعاملات
              التي تمت قبل تاريخ إبلاغه للشركة. ويتم الإبلاغ عن طريق الاتصال
              بخدمة العملاء الخاصة بالشركة لوقف الخدمة، وفي حالة رغبة المستخدم
              إعادة تفعيل الخدمة، يتعين عليه التواصل مع خدمة العملاء الخاصة
              بالشركة.
            </li>
            <li>
              يحق للبنك وضع حدود قصوى لرصيد البطاقة ولقيمة وعدد كل من العمليات
              اليومية والشهرية، كما يحق للبنك تغيرها من وقت لآخر مع اخطار
              المستخدم بأي وسيلة مناسبة يراها البنك. ويعتبر استخدام المستخدم
              للخدمة بعد تعديل تلك الحدود بمثابة موافقة منه، ويتم ذلك في ضوء
              سياسة البنك ووفقاً للقواعد المنظمة لهذه الخدمة والصادرة من البنك
              المركزي المصري. وتتم عمليات التحويل داخل جمهورية مصر العربية فقط
              وبالعملة المحلية (الجنيه المصري فقط) ولا يحوز إجراء عمليات تبادل
              العملات أو مقاصة من حسابات المستخدمين ذات الصلات الأخرى ويسمح
              لمستخدمي الخدمة بتلقي تحويلات من الخارج بالعملات الأجنبية، ويتم
              اضافتها إلى حسابتهم بالجنيه المصري، وذلك بشرط خضوع المستخدم
              لإجراءات التعرف على الهوية وفقاً لقواعد التعرف على الهوية الصادرة
              عن وحدة غسل الأموال وتمويل الإرهاب التابعة للبنك المركزي المصري.
            </li>

            <li>
              يحق للبنك رفض تنفيذ أي عملية يراها البنك غير مناسبة، كما يحق له
              عدم الافصاح عن اسباب ذلك الرفض. ويتخذ البنك الإجراءات اللازمة
              للتأكد من أن التحويل يخص المستخدم ذاته، وأن القيمة لقد تم إضافتها
              بالجنيه المصري لحساب البطاقة الخاصة به وعلى المستخدم حماية الرقم
              السري الخاص به والإبلاغ فوراً عند فقد بطاقته.
            </li>
            <li>
              في حالة وجود شكوى او نزاع مالي نتيجة استخدام الخدمة من قبل
              المستخدم، يتعين على المستخدم التوجه إلى أقرب فرع من فروع الشركة
              وتقديم الشكوى خطياً، أو الاتصال بأرقام خدمة العملاء الخاصة بالشركة
              أو الخط الساخن ( 16629 ) وسيتم الرد عليه خلال عشرة أيام عمل ( 10 )
              عمل من تاريخ تقديم الشكوى، وذلك باستثناء الشكاوى المتعلقة
              بالمعاملات الخارجية ويتم اخطار المستخدم بالمدة اللازمة لدراسة
              الشكوى.
            </li>

            <li>
              تولي المناصب العامة العليا أو الارتباط بمن يتولاها حتى الدرجة
              الثانية: وفقا للتعريف هم الاشخاص الذين يشغلون مناصب عامة عليا في
              مصر أو في دولة اجنبية أو منظمة دولية سواء حالياً أو سابقاً، وعلى
              سبيل المثال لا الحصر: رؤساء الدول أو الحكومات وأفراد العائلات
              المالكة والحكمة بأي دولة والوزراء وتوابعهم وكبار مساعديهم رؤساء
              واعضاء المجالس النيابية والمجالس المحلية والبلديات، المحافظين
              ونوابهم ورؤساء المدن ونوابهم والصد ونوابهم ورؤساء وأعضاء المجالس
              المتخصصة )مثل: المجلس القومي للمرأة، المجلس القومي لحقوق الانسان(
              وكبار السياسيين، وكبار مسئولي الحكومة والمسئولين السكريين
              والمسئولين الرئيسيين في الجهات القضائية )على سبيل المثال: رئيس
              المحكمة الدستورية ونوابه، رئيس المجلس الأعلى للقضاء ونوابه، رئيس
              محكمة النقض ونوابه رئيس محكمة الاستئناف ونوابه، النائب العام وكبار
              مساعديه(، ورؤساء الشركات المملوكة للدولة ونوابهم وكبار مساعديهم،
              ورؤساء وأعضاء الهيئات العليا بالأحزاب السياسية وكبار الدبلوماسيين
              والمنظمات الدبلوماسية الدولية )على سبيل المثال: الأمم المتحدة،
              اليونسكو الخ(، رؤساء واعضاء مجالس ادارة النقابات ورؤساء وأعضاء
              مجالس الجامعات الحكومية .
            </li>
            <li>
              لتأكيد على أوقات توفير الخدمة طبقا لتقييم البنك لهدف وقت الاسترجاع
              RTO الوارد في خطة استمرارية الأعمال، وينبغي إخطار العملاء في حالة
              انقطاع الخدمة لعمل صيانة محددة مسبقا.
            </li>
            <li>
              على العميل ان يعي ان موظفي البنك أو وكلائه لا يجوز لهم أن يطلبوا
              من مستخدم النظام الإفصاح عن البيانات السرية الأرقام التعريفية أو
              كلمات السر عن طريق البريد الإلكتروني او غيره وفي حالة وقوع ذلك يجب
              على مستخدم النظام الاتصال بالبنك في أسرع وقت ممكن.
            </li>
            <li>
              . يمكن للعميل الاطلاع على المنافذ المعتمدة من خلال تطبيق لاكي او
              الاستفسار من الخط الساخن لشركة لاكي 16629
            </li>
            <li>
              التزام مستخدم النظام بقراءة التحذيرات والإطارات التنبيهية (مثل
              التنبيهات الأمنية أو تنبيهات محاولات الاحتيال / الهندسة الاجتماعية
              Social Engineering.. إلخ ) والتأكيد أيضًا على أن قبول مُستخدم
              النظام من خلال تطبيق الهاتف المحمول لأي تغيير في الشروط والأحكام
              الذي سيظهر من خلال النظام إلكترونيا يعتبر التزاماً قانونياً
            </li>
            <li>
              يجب أن يكون الهاتف المحمول الخاص بمُستخدم النظام والمستخدم غير
              مخترق Jailbroken/Rooted
            </li>
            <li>
              القوانين المصرية ذات الصلة ولوائحها التنفيذية والتعليمات والقواعد
              الرقابية هي التي تحكم الخدمات التي يقوم البنك بتقديمها للعملاء عبر
              الهاتف المحمول ويتم تسوية النزاعات داخل جمهورية مصر العربية.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default ContractDebit;
